import {
  CHANGE_MAP,
} from './types';

export function changeMap(game,map){
    return {
        type: CHANGE_MAP,
        payload: {game: game, map: map},
    };
}



// WEBPACK FOOTER //
// ./src/app/actions/ts_map_actions.js